module.exports = __webpack_public_path__ + "static/media/timestampIcon.4636c3a2.svg";